import bliss from "../assets/images/windowsBackground.jpg";

export type WallpaperId = "bliss" | "teal" | "midnight" | "tiles" | "sunset";

export interface Wallpaper {
  id: WallpaperId;
  name: string;
  // any valid CSS `background` value
  background: string;
}

export const WALLPAPERS: Wallpaper[] = [
  {
    id: "bliss",
    name: "Bliss",
    background: `#bfbfbf url(${bliss}) center / cover no-repeat`,
  },
  {
    id: "teal",
    name: "Classic Teal",
    background: "#008080",
  },
  {
    id: "midnight",
    name: "Midnight",
    background: `radial-gradient(1px 1px at 20% 30%, #fff 50%, transparent 51%),
      radial-gradient(1px 1px at 70% 20%, #fff 50%, transparent 51%),
      radial-gradient(1.5px 1.5px at 40% 70%, #fff 50%, transparent 51%),
      radial-gradient(1px 1px at 85% 60%, #fff 50%, transparent 51%),
      radial-gradient(1.5px 1.5px at 10% 85%, #fff 50%, transparent 51%),
      radial-gradient(1px 1px at 55% 45%, #fff 50%, transparent 51%),
      radial-gradient(ellipse at bottom, #1b2a6b 0%, #050818 70%)`,
  },
  {
    id: "tiles",
    name: "Plus! Tiles",
    background: `repeating-conic-gradient(#3a6ea5 0% 25%, #4a7fb8 0% 50%) 0 0 / 48px 48px`,
  },
  {
    id: "sunset",
    name: "Vaporwave",
    background: `linear-gradient(180deg, #2b1055 0%, #7597de 45%, #ff6ec7 75%, #ffb86c 100%)`,
  },
];

export const getWallpaper = (id: WallpaperId) =>
  WALLPAPERS.find((wallpaper) => wallpaper.id === id) || WALLPAPERS[0];
